import { useState } from "react";
import { i18n, languages, } from "@about-mink/info";
export { languages };
var getLanguage = function () {
    var subpaths = window
        .location
        .pathname
        .split("/")
        .filter(function (a) { return a.length > 0; });
    for (var _i = 0, languages_1 = languages; _i < languages_1.length; _i++) {
        var language = languages_1[_i];
        if (subpaths[0] === language)
            return language;
    }
    return "en";
};
export var useData = function () {
    var data = useState(function () { return i18n; })[0];
    return data;
};
export var tr = function (text) {
    if (!text)
        return "";
    var lang = getLanguage();
    return text[lang];
};
export var getPicture = function (data, name) {
    var pictures = data.pictures;
    for (var _i = 0, pictures_1 = pictures; _i < pictures_1.length; _i++) {
        var picture = pictures_1[_i];
        if (picture.name === name)
            return picture.url;
    }
    throw new Error("Picture ".concat(name, " not found"));
};
